export default "__VITE_ASSET__Bvj8TObN__"